/* RESPONSIBLE TEAM: team-inbox */
import EmbercomBaseSerializer from './base/embercom-base-serializer';

export default class CopilotSettingsSerializer extends EmbercomBaseSerializer {}
